module.exports = __webpack_public_path__ + "fonts/Inter-100-vietnamese8.74fe938.woff2";